import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import santoshImage from '../../../../public/assets/santosh.jpeg';
import siddharthaImage from '../../../../public/assets/sid.jpeg';

const IndustryTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      author: 'Santosh S.',
      role: 'Co-founder and CEO',
      company: 'Planeo',
      avatar: santoshImage,
      avatarAlt: 'Professional headshot of confident woman with shoulder-length brown hair wearing navy blazer and white blouse in modern office setting',
      quote: 'Abhishek is a very talented engineer and is well versed in frontend/backend systems. He was very instrumental in designing and implementing our web app. His communication is top notch and also went way beyond his comfort zone in helping us iron out many issues. I already worked with him twice, and he is going to be our go to resource moving forward as well. I would highly recommend Abhishek to anyone who is seeking help, be it designing, coding or building out webapps. ',
      rating: 5,
    },
    {
      id: 2,
      author: 'Siddhartha Gupta',
      role: 'CEO',
      company: 'Zeliant Retail Private Limited',
      avatar: siddharthaImage,
      avatarAlt: 'Professional headshot of Asian businessman with short black hair wearing charcoal suit and blue tie with confident smile',
      quote: 'Abhishek has truly elevated my experience on Upwork. Their expertise and dedication were instrumental in creating my product catalogue website. From crafting seamless user interfaces to ensuring optimal functionality, Abhishek demonstrated remarkable skill and professionalism throughout the project. Their proactive communication and problem-solving abilities were invaluable, making the collaboration not just productive but enjoyable. I highly recommend Abhishek to anyone seeking top-tier frontend development services on Upwork.',
      rating: 5,
    },
  ];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full text-sm font-medium font-body mb-4">
            <Icon name="MessageSquare" size={16} />
            <span>Client Success Stories</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-4">
            What Industry Leaders Say
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Real transformation stories from executives who trusted us with their critical projects
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-border flex flex-col h-full">

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, index) =>
              <Icon key={index} name="Star" size={16} className="text-warning fill-warning" />
              )}
              </div>
              
              <blockquote className="text-sm md:text-base text-foreground font-body mb-6 flex-1 leading-relaxed">
                "{testimonial?.quote}"
              </blockquote>
              
              <div className="flex items-center space-x-4 pt-4 border-t border-border">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />

                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-foreground font-headline text-sm md:text-base">
                    {testimonial?.author}
                  </div>
                  <div className="text-xs md:text-sm text-muted-foreground font-body">
                    {testimonial?.role}
                  </div>
                  <div className="text-xs text-muted-foreground font-body">
                    {testimonial?.company}
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
                    {testimonial?.industry}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default IndustryTestimonials;